import { hash } from 'ohash';
import { storageKey } from '#layers/base/utils/storage-key';

/**
 * Returns an opaque workspace scoped key that can be used for persisting local storage data.
 */
export function workspaceScopedKey(key?: string) {
	// TODO actually use current workspace uuid as a prefix

	if (!key) {
		return storageKey('workspace');
	}

	// TODO should this hash the whole identifier, or only the key after the workspace UUID?
	// TODO should we disable hashing in dev-mode for easier debugging?
	return storageKey(`workspace:${hash(key)}`);
}
